import { getUserById } from '../../data/users';
import { formatDateString } from './calDateHelpers';

/**
 * Extracts dates from slots data for month availability
 */
export function extractDatesFromSlots(slotsData: any[]): Set<string> {
  const datesWithAvailability = new Set<string>();
  
  if (Array.isArray(slotsData)) {
    slotsData.forEach((slot: any) => {
      const timeValue = slot.time || slot.start || slot;
      if (timeValue) {
        try {
          const slotDate = new Date(timeValue);
          if (!isNaN(slotDate.getTime())) {
            const dateStr = formatDateString(slotDate);
            datesWithAvailability.add(dateStr);
          }
        } catch (e) {
          // Ignore invalid slots
        }
      }
    });
  }

  return datesWithAvailability;
}

/**
 * Gets user first-timer status for shooting bookings
 * Returns true if no director_id is assigned
 */
export async function getUserFirstTimerStatus(userId?: string): Promise<boolean | undefined> {
  if (!userId) return undefined;
  
  const userResult = await getUserById(userId);
  if (userResult.success && userResult.data) {
    return !userResult.data.director_id;
  }
  return undefined;
}

/**
 * Gets user first-timer status for editorial/preparation bookings
 * Returns true if no personal_brand_manager_id is assigned
 */
export async function getUserEditorialFirstTimerStatus(userId?: string): Promise<boolean | undefined> {
  if (!userId) return undefined;
  
  const userResult = await getUserById(userId);
  if (userResult.success && userResult.data) {
    return !userResult.data.personal_brand_manager_id;
  }
  return undefined;
}

